import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const NsfOverdraftProcessPayloadSchema = z.object({
    cases: z.number().optional(),
});

export class NsfOverdraftProcessPayload extends FromSchema(NsfOverdraftProcessPayloadSchema) {
    cases?: number;
}
